import { FC, useCallback, useEffect, useState } from 'react'
import { MainLayout } from 'views/layouts'
import { useNavigate } from 'react-router-dom'
import {
  BtnGoBack,
  ContainerActionItem,
  DeleteTag,
  GridModal,
  LinkTo,
  ModalBody,
  ModalContainer,
  Row,
  SaveButton,
  UpdateTag,
  ViewTag,
} from './styled'
import { StrokedButton } from 'views/components/UI/Buttons'
import EditIcon from 'assets/icons/EditCoin'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import TitleDiv from 'views/components/UI/TitleDiv'
import ActionDetailModal from './action-detail-modal/action-detail-modal'
import { fetchAllActions } from '../../services/fetch-betesa-talents'
import BluesiteTableComponent from 'views/components/UI/BluesiteTable'
import { HEADERS } from '../../constants'
import { specialAdminRoutes } from 'router/routes'
import fetchDeleteDevelopmentPlanById from 'services/developmentActions/fetchDeleteDevelopmentPlanById/fetchDeleteDevelopmentPlanById'
import { useNotification } from 'lib/context/notification.context'
import Modal from 'views/components/UI/Modal'

interface DevelopmentPlansProps {
  id?: number
}

const DevelopmentPlans: FC<DevelopmentPlansProps> = () => {
  const [actions, setActions] = useState([])
  const [actionId, setActionId] = useState(0)
  const [openModal, setOpenModal] = useState(false)
  const [deleteActionId, setDeleteActionId] = useState<number | null>(null)
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [totalPages, setTotalPages] = useState(0)
  const [searchParam, setSearchParam] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const navigate = useNavigate()
  const { getError } = useNotification()

  const getAllDevelopmentActions = useCallback(
    (page = 1, limit = 10) => {
      setCurrentPage(page)
      fetchAllActions(limit, page, searchParam).then(({ development_plans, total_pages }) => {
        setActions(development_plans)
        setTotalPages(total_pages)
      })
    },
    [searchParam]
  )

  const handleDeleteButton = () => {
    if (!deleteActionId) {
      getError('No se pudo obtener el id de la acción de desarrollo')
      return
    }

    fetchDeleteDevelopmentPlanById(deleteActionId).then((response) => {
      if (response?.ok === false || response?.status === 'error') {
        getError(response.message || 'No se pudo eliminar la acción de desarrollo')
        return
      }

      setOpenDeleteModal(false)
      setDeleteActionId(null)
      getAllDevelopmentActions(currentPage)
    })
  }

  useEffect(() => {
    getAllDevelopmentActions()
  }, [getAllDevelopmentActions])

  const ActionComponent = useCallback((props: any) => {
    const { id } = props

    const handleActionAndOpenModalClick = () => {
      setActionId(id)
      setOpenModal(true)
    }

    const handleActionAndOpenDeleteModalClick = () => {
      setDeleteActionId(id)
      setOpenDeleteModal(true)
    }

    return (
      <ContainerActionItem>
        <ViewTag
          onClick={() => {
            handleActionAndOpenModalClick()
          }}
        >
          Ver
        </ViewTag>
        <LinkTo
          onPointerDown={(event) => {
            if (event.button !== 0) return
            event.preventDefault()
            navigate('/modules/talents/edit', { state: { props } })
          }}
        >
          <UpdateTag>
            <EditIcon /> Editar
          </UpdateTag>
        </LinkTo>
        <DeleteTag onClick={handleActionAndOpenDeleteModalClick}>Eliminar</DeleteTag>
      </ContainerActionItem>
    )
  }, [navigate])

  return (
    <MainLayout>
      <TitleDiv>
        <h2 style={{ fontSize: 32 }}>Acciones de desarrollo por talentos</h2>
        <StrokedButton
          type="button"
          onClick={() => {
            navigate(specialAdminRoutes.NewBetesaTalent)
          }}
        >
          Nuevo talento
        </StrokedButton>
      </TitleDiv>

      <BluesiteTableComponent
        data={actions}
        headers={HEADERS}
        searchBar={true}
        ActionComponent={ActionComponent}
        searchLabel=""
        totalPages={totalPages}
        handlePagination={getAllDevelopmentActions}
        handleSearchFunction={() => getAllDevelopmentActions()}
        currentPage={currentPage}
        setSearchParam={setSearchParam}
        onSearch={setSearchParam}
      />

      <ActionDetailModal openModal={openModal} setOpenModal={setOpenModal} actionId={actionId} />
      <Modal
        hideCloseButton={true}
        show={openDeleteModal}
        setShow={setOpenDeleteModal}
        styleContent={{
          width: '560px',
          height: '280px',
          borderRadius: '10px',
          padding: '20px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          backgroundColor: '#FFFFFF',
        }}
      >
        <ModalContainer>
          <ModalBody>
            <DeleteOutlineOutlinedIcon />
            <h3 style={{ textAlign: 'center' }}>¿Seguro que deseas eliminar esta acción?</h3>
            <GridModal>
              <p style={{ width: '100%', marginTop: 0, color: '#303030', textAlign: 'center' }}>
                Si eliminas esta acción no podrás volver a acceder a ella
              </p>
              <Row>
                <BtnGoBack
                  onClick={() => {
                    setOpenDeleteModal(false)
                  }}
                >
                  Cancelar
                </BtnGoBack>
                <SaveButton onClick={handleDeleteButton}>Eliminar</SaveButton>
              </Row>
            </GridModal>
          </ModalBody>
        </ModalContainer>
      </Modal>
    </MainLayout>
  )
}

export default DevelopmentPlans
